<template lang="pug">
  Modal(ref="modal" title="Package Details" closable="true")
    .package-details-modal-body.ssp-form-horizontal
      .parent(v-if="details")
        a.child.kzcode-default(v-for="d in details.package" @click="traceCode(d.uid)") {{d.uid}}
    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  data: () => ({
    details: null
  }),
  methods: {
    open(details) {
      this.details = details
      this.$refs.modal.open();
    },
    traceCode(code) {
      this.$router.push(`/trackntrace/dashboards/trace/${code}`)
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.package-details-modal-body {
  .parent {
    display: flex;
    flex-wrap:wrap;
  }
  .child {
    display: inline-block;
    width: calc(100% * (1/4))
  }
  .child:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/PackageTypeDetailsModal.vue